export default function html(el, content) {
	if (!el) {
		return;
	}

	if (content) {
		el.innerHTML = content;
	} else {
		return el.innerHTML;
	}
}
